import jsPDF from "jspdf";

export const nextY = (doc: jsPDF) => {
  const lastY = (doc as any).lastAutoTable?.finalY;
  return lastY !== undefined ? lastY + 10 : 10;
}

export const isValidValue = (value: any): boolean => {
  if (value === undefined || value === null) return false;
  if (typeof value === "string" && value.trim() === "") return false;
  return true;
};

export const  percentageLabel = (pct: number): string  => {
  let display: number;
  if (pct > 1) {
    display = pct;
  } else {
    display = pct * 100;
  }
  const s = Math.round(display * 100) / 100;
  return `${s} %`;
}
